import { ParamsValidator } from "@whilecat/core/tasks/validators/params-validator.js";
import { requireNotNull, sanityCheck } from "@whilecat/core/utils/validation.js";
import type { TemplateResult } from "lit";

export type MarkLinesParams = {
    correctLines: Array<number>;
    content: TemplateResult;
    code: string;
};

export class MarkLinesParamsValidator extends ParamsValidator<MarkLinesParams> {
    validate(params: MarkLinesParams): void {
        requireNotNull(params.content);

        const linesCount = params.code.split("\n").length;

        params.correctLines.forEach(lineNumber => {
            sanityCheck(lineNumber > 0 && lineNumber <= linesCount, `Must be in rage 1..${linesCount}`);
        });
    }
}
